import { Camera } from "./Camera";
import { mat4, vec3 } from "gl-matrix";
import { ViewPort } from "./ViewPort";
import { toRadian } from "@spi/Common/Math";
import { PropertyAnimation } from "@spi/Common/Animation";


export class AttachedCamera extends Camera {

    public animatedProperties: PropertyAnimation;
    private lastLocation: vec3;
    private lastRotation: number;
    private _rotation: number;
    private target: CameraTargetType;

    constructor(viewPort: ViewPort) {
        super(viewPort);

        this.lastLocation = vec3.create();
        this.lastRotation = 0;
        this._rotation = 0;
        this.target = null;
    }

    public attach(target: CameraTargetType): void {
        this.target = target;
    }

    public get rotation(): number {
        return this._rotation;
    }

    protected applyModelView(matrix: mat4): void {
        if (!this.target) {
            return;
        }

        let rotation = this._rotation - 180;

        let dist = 25;

        mat4.lookAt(matrix,
            vec3.fromValues( // camera
                this.target.position[0] + dist * Math.sin(-toRadian(rotation)), // rotate around the location
                this.target.position[1] + dist * Math.cos(-toRadian(rotation)),
                this.target.position[2] + 10 // Up in the air a bit
            ),
            this.target.position, // location
            vec3.fromValues(0, 0, 1) // z is up
        );
    }

    public get position() : vec3 | number[] {
        return this.target.position;
    }

    public prepareFrame(): void {
        if (!this.target) {
            return;
        }

        if(this.animatedProperties) {
            this.animatedProperties.step();
        }

        if (Math.abs(this.lastRotation - this.target.rotation) > 0.0001) {
            this.invalidatedModelView = true;

            this.lastRotation = this.target.rotation;
            this.rotate(this.lastRotation);
        }
        if (vec3.dist(this.lastLocation, this.target.position) > 0.0001) {
            this.invalidatedModelView = true;
            vec3.copy(this.lastLocation, this.target.position);
        }
    }

    private rotate(newRotation: number) {
        this.animatedProperties = new PropertyAnimation(this, () => { });
        this.animatedProperties.animate([{ property: '_rotation', value: newRotation, speed: 5 }]);
    }

}

type CameraTargetType = {
    position: vec3 | number[],
    rotation: number
}